import type { ComponentProps } from 'react'

import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  type IconProps,
} from 'components'

export const DateTransfer = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M29.4792 45.8333V42.7083H40.6251V20.3125H9.37508V31.7708H6.25008V10.4166C6.25008 9.58329 6.56258 8.85413 7.18758 8.22913C7.81258 7.60413 8.54175 7.29163 9.37508 7.29163H12.7605V4.16663H16.1459V7.29163H33.8542V4.16663H37.2397V7.29163H40.6251C41.4584 7.29163 42.1876 7.60413 42.8126 8.22913C43.4376 8.85413 43.7501 9.58329 43.7501 10.4166V42.7083C43.7501 43.5416 43.4376 44.2708 42.8126 44.8958C42.1876 45.5208 41.4584 45.8333 40.6251 45.8333H29.4792ZM16.6667 49.2708L14.4792 47.0833L20.3647 41.1458H2.60425V38.0208H20.3647L14.4792 32.0833L16.6667 29.8958L26.3542 39.5833L16.6667 49.2708ZM9.37508 17.1875H40.6251V10.4166H9.37508V17.1875ZM9.37508 17.1875V10.4166V17.1875Z"
        fill={color}
      />
    </svg>
  )
}
